import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { EditionAwarenessContextType } from './edition-awareness-context';
import { isEligibleForStandardToPremium } from './is-eligible-for-standard-to-premium';

export function isEligibleForStandardToPremiumIncentiveOffer(
	context: EditionAwarenessContextType,
): boolean {
	return (
		isEligibleForStandardToPremium(context) &&
		fg('standard_to_premium_incentive_offer_ea_kill_switch')
	);
}
